//import { render } from "@testing-library/react";
import React,{useState} from "react";
import {Modal,Button} from 'react-bootstrap';
//import Back from "./Back";
import { withRouter } from "react-router-dom";
import config from "../config";
import errorlogo from "./images/error.png";
//const axios = require("axios");
//const history = useHistory();

const ModalLogin = ({history})=> {
  const [isOpen, setisOpen]=useState(true);
  const closeModal=(e)=>{setisOpen(false); history.goBack();}
  return(
history.length > 1 && (

  <React.Fragment>
  <Modal  show={isOpen} onHide={closeModal} backdrop="static" aria-labelledby="contained-modal-title-vcenter" animation={false} centered>
    <Modal.Header closeButton style={{backgroundColor:"black", color:"white", height:"40px", paddingTop:2}}>
      <Modal.Title style={{ paddingTop:0, paddingLeft:2}}>  {config.gvr.ErrMsgs.TitleNotLoggedin}</Modal.Title>
    </Modal.Header> 
{/*}    <Modal.Body style={{ height:"75px"}}><div style={{width:"5px", height:"25px", float:"left",paddingLeft:"5px"}}><img src={errorlogo} style={{height:"20px",width:"20px"}}/></div><div style={{width:"40px",height:"75px",paddingLeft:5,float:"right"}}>{config.gvr.ErrMsgs.MsgNotLoggedin}</div></Modal.Body>*/}
    <Modal.Body style={{ height:"75px"}}><img src={errorlogo} alt="" style={{height:"25px",width:"25px",float:"left"}}/><div style={{width:"92%",height:"30px",float:"right"}}><b>{config.gvr.ErrMsgs.MsgNotLoggedin}</b></div>
    
    </Modal.Body>
    <Modal.Footer>
      <Button variant="primary" onClick={closeModal}  style={{backgroundColor:"gray", borderColor:"black"}}>
        Login 
      </Button>
    </Modal.Footer>
  </Modal>
</React.Fragment>));
  }



export default withRouter(ModalLogin);
  /*class ModalLogin extends Component {
  constructor(props) { 
        super(props);
        this.state = {heading:props.heading,
            isLoaded: false,
            isOpen:true,

        }
    //    this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        self = this;

    }
    openModal(e){this.setState({ isOpen: true });}
    closeModal=(e)=>{this.setState({ isOpen: false });this.props.history.goBack();}

    render(){
        return(
        <>
        <Modal show={self.state.isOpen} onHide={self.closeModal}  backdrop="static" aria-labelledby="contained-modal-title-vcenter" animation={false} centered  >
          <Modal.Header closeButton style={{backgroundColor:"#ff2509", color:"white", height:"40px", paddingTop:2}}>
            <Modal.Title style={{ paddingTop:0}}  >Error Login</Modal.Title>
          </Modal.Header> 
          <Modal.Body style={{ height:"50px"}}>Sorry, currently you are not logged in OR your login session has been expired.</Modal.Body>
          <Modal.Footer>
            <Back/>
            <Button variant="primary" onClick={self.closeModal} style={{backgroundColor:"#ff2509"}}>
              Login 
            </Button>
          </Modal.Footer>
        </Modal>
      </>
        )
        }
  }      
  export default withRouter(ModalLogin);*/